const postFeatureFlags = {
  toastr: 'Tenant actualizado',
  toastr1: ' fue actualizado con éxito'
};

export default postFeatureFlags;
